import styled from 'styled-components';
import { FlexCenteredColumn } from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';

export const Divider = styled.div`
  height: 1px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
`;

export const NewSearchEmptyContainer = styled(FlexCenteredColumn)`
  padding-top: 20px;
`;

export const NewSearchEmptyText = styled(Typography)`
  margin-top: 30px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const NewSearchEmptyLink = styled.a`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.systemColors.blue};
  font-size: 15px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.background.primary};
  padding: 10px 15px;
  border-radius: 14px;
`;

export const NewSearchEmptyTitle = styled.div`
  margin: 15px 0;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
`;
